const btnGroup = document.querySelector(".btn-group");
const burgerBtn = btnGroup.querySelector(".burger-btn");

let active = false;
let os = 0;
function setActive(value) {
  btnGroup.style.transition = "transform 400ms";
  if (value) {
    document.body.classList.add("active-nav");
    btnGroup.style.transform = "translateY(0)";
    active = true;
  } else {
    document.body.classList.remove("active-nav");
    btnGroup.style.transform = `translateY(-${os}px)`;
    active = false;
  }
}
burgerBtn.onclick = function () {
  setActive(!active);
};
window.onkeydown = function (e) {
  if (e.key === "Escape") {
    setActive(false);
  }
};

window.onscroll = function() {
  os = document.documentElement.scrollTop;
  btnGroup.style.transition = "none";
  btnGroup.style.transform = `translateY(-${os}px)`;
}
window.onscroll();
btnGroup.style.display = "flex";
